export default __webpack_public_path__ + "static/media/icon-self-assessment-active.5bf2eabe.svg";